//#region Module
import { useState } from "react";
// material
import { Select, MenuItem } from "@mui/material";
import { ReactComponent as DropDownIcon } from "../../../assets/icons/icon-angle-down.svg"
//#endregion

const SORT_BY_OPTIONS = [
    // { sortKey: "updatedAt", sortOrder: "-1", value: "Sort by", label: "Sort by" },
    { sortKey: "updatedAt", sortOrder: "-1", value: "updatedDesc", label: "Last updated (New first)" },
    { sortKey: "updatedAt", sortOrder: "1", value: "updatedAsc", label: "Last updated (Old first)" },
    { sortKey: "reportName", sortOrder: "1", value: "reportNameAsc", label: "Analysis name (A-Z)" },
    { sortKey: "reportName", sortOrder: "-1", value: "reportNameDesc", label: "Analysis name (Z-A)" }
]

export default function ReportSort(props) {
    const {handleSort, className} = props
    const [sortValue, setSortValue] = useState(SORT_BY_OPTIONS[0].value);
    const [dropdownStatus, setDropdownStatus] = useState(false)

    const handleChange = (event) => {
        let { value } = event.target
        handleSort(SORT_BY_OPTIONS.find(o => o.value === value))
        setSortValue(value)
    }

    return (
        <>
            <Select
                value={sortValue}
                onChange={(val)=>handleChange(val)}
                autoWidth={false}
                className={className + " report-form-select" + (dropdownStatus ? ` is-open ` : ` `) }
                IconComponent={DropDownIcon}
                onClose={() => setDropdownStatus(false)}
                onOpen={() => setDropdownStatus(true)}
                MenuProps={{
                    anchorOrigin: {
                      vertical: "bottom",
                      horizontal: "left"
                    },
                    transformOrigin: {
                      vertical: "top",
                      horizontal: "left"
                    },
                    getContentAnchorEl: null,
                    classes:{
                        root: `form-select-menu`,
                    },
                }}
                >
                {SORT_BY_OPTIONS.map((option) => (
                    <MenuItem track-this="Report Sort" tracked-type="button" 
                    value={option.value} key={option.value}>{option.label}</MenuItem>
                ))}
            </Select>
        </>
    )
}